import { render, staticRenderFns } from "./AddEntriesToJournalBatch.vue?vue&type=template&id=19700ca1&scoped=true&"
import script from "./AddEntriesToJournalBatch.vue?vue&type=script&lang=js&"
export * from "./AddEntriesToJournalBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19700ca1",
  null
  
)

export default component.exports